import { render, staticRenderFns } from "./OrderableItemFixtureDetails.vue?vue&type=template&id=25383d16&"
import script from "./OrderableItemFixtureDetails.vue?vue&type=script&lang=ts&"
export * from "./OrderableItemFixtureDetails.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports